import { FC } from 'react'
import { TProduct } from './Product.types'
import { IconButton } from '@mui/material'
import './Product.scss'

import DeleteIcon from '@mui/icons-material/Delete'

export const Product: FC<TProduct> = (props) => {
  const { item, onDelete } = props

  return (
    <div className="special-request-product-container">
      <div className="name">{item.name}</div>
      <div className="actions">
        <IconButton onClick={() => onDelete(item)}>
          <DeleteIcon />
        </IconButton>
      </div>
    </div>
  )
}
